<template>
  <div class="!pt-0">
    <div
      class="flex flex-col max-h-screen pt-16 pb-2.5 min-h-screen space-y-2.5"
      style="--animate-duration: 0.2s;"
    >
      <div class="flex items-stretch justify-between mt-2.5">
        <div class="flex space-x-2 element-island">
          <h1 class="font-semibold text-3xl">
            {{ report?.title }}
          </h1>
        </div>

        <div
          class="element-island flex items-center space-x-4"
        >
          <RouterLink
            :to="{ name: 'ReportsIndex', params: { projectId: props.projectId } }"
            class="btn btn--secondary-blue flex items-center space-x-2"
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
    <path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
    <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
  </svg>

            <span>
              View all project reports
            </span>
          </RouterLink>

          <RouterLink
            :to="{ name: 'ReportEditor', params: { projectId: props.projectId, reportId: props.reportId } }"
            class="btn btn--secondary-blue flex items-center space-x-2"
          >
            <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 class="w-5 h-5">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
    />
</svg>

            <span>
              Configure Report
            </span>
          </RouterLink>

          <button
            type="button"
            class="btn btn--secondary-blue flex items-center space-x-2"
            @click="showExportReportModal = true"
          >
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" class="w-5 h-5">
<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
</svg>

            <span>
              Export Report
            </span>
          </button>

          <button
            v-if="report?.issue_to?.length > 0 && mediaCollection.mediaCollection.value?.length > 0"
            type="button"
            class="btn btn--secondary-blue flex items-center space-x-2"
            @click="showIssueToModal = true"
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
    <path stroke-linecap="round" stroke-linejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75" />
</svg>

            <span>
              Issue Report
            </span>
          </button>
        </div>
      </div>

      <Transition
        enter-active-class="animate__animated animate__fadeIn"
        leave-active-class="animate__animated animate__fadeOut"
        mode="out-in"
      >
        <div
          v-if="showReportsAction.is(States.LOADING)"
          class="element-island m-auto flex flex-col items-center justify-center"
        >
          <div class="w-full text-center p-2 px-10">
            <h1 class="text-2xl">
              Loading reports...
            </h1>
          </div>


          <div class="py-10 mx-auto">
            <AppSpinner />
          </div>
        </div>

        <div
          v-else-if="mediaCollection.mediaCollection.value?.length > 0"
          class="element-island overflow-y-auto flex flex-1 p-4"
        >
          <div
            class="flex w-full"
          >
            <template v-if="mediaCollection.mediaCollection.value.length > 0">
              <div class="w-1/4 flex">
                <div class="w-full overflow-y-auto relative h-full mr-2">
                  <div class="absolute inset-0 overflow-y-auto">
                    <div class="p-2">
                      <ul class="space-y-2">
                        <li
                          v-for="(media, i) in orderedReports"
                          :key="media.uuid"
                          class="p-2 rounded-lg cursor-pointer"
                          :class="{ 'bg-gray-300': media.uuid === selectedReport?.uuid }"
                          @click="selectReport(i)"
                        >
                          <div>
                            Report for period
                            {{ transformPeriod(media.custom_properties.period) }}
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div class="w-3/4">
                <iframe
                  v-if="selectedReport"
                  :src="selectedReport.custom_properties.access_url"
                  frameborder="0"
                  class="w-full h-full"
                />
              </div>
            </template>
          </div>
        </div>

        <div
          v-else
          class="element-island m-auto"
        >
          <div class="w-full text-center p-2 px-10">
            <h1 class="text-2xl">
              Export Monthly Report
            </h1>
          </div>

          <div class="flex flex-col space-y-4">
            <label>
              Month

              <AppInput
                v-model="reportMonth"
                name="month"
                type="month"
                class="form-input"
              />
            </label>

            <button
              type="button"
              class="btn btn--primary-blue flex items-center justify-center space-x-2"
              :disabled="generateReportAction.is(States.LOADING)"
              @click="exportMonthlyReport"
            >
              <svg
    fill="none"
    viewBox="0 0 24 24"
 v-if="generateReportAction.is(States.LOADING)"
               
                class="animate-spin h-5 w-5 text-white">
    <circle
        class="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        stroke-width="4"
    />

    <path
        class="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    />
</svg>

              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" v-else
               
                class="w-5 h-5">
<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
</svg>

              <span>Generate Report</span>
            </button>
          </div>
        </div>
      </Transition>
    </div>

    <GenerateExportModal
      v-if="showExportReportModal"
      :report="report"
      @close="showExportReportModal = false"
    />

    <IssueToModal
      v-if="showIssueToModal"
      :report="report"
      :available-reports="orderedReports"
      @close="showIssueToModal = false"
    />
  </div>
</template>

<script setup lang="ts">
import GenerateExportModal from '@/components/Reports/ReportShow/GenerateExportModal.vue';
import IssueToModal from '@/components/Reports/ReportShow/IssueToModal.vue';
import { Media, useMediaCollection } from '@/composables/useMediaCollection';
import { States, useStoreApiAction } from '@/composables/useStoreApiAction';
import { dateForMonthInput } from '@/helpers';
import { useReportsStore } from '@/store/reports';
import { DateTime } from 'luxon';
import Swal from 'sweetalert2';
import { computed, ref, watch } from 'vue';
import { useRouter } from 'vue-router';

interface Props {
  projectId: string;
  reportId: string;
}

const props = defineProps<Props>();
const reportsStore = useReportsStore();
const mediaCollection = useMediaCollection(async () => ({}));
const selectedReport = ref<Media | undefined>();
const showExportReportModal = ref(false);
const showIssueToModal = ref(false);
const router = useRouter();

// Fetch the report data
const report = computed(() => {
  return reportsStore.models.find(parseInt(props.reportId));
});

const orderedReports = computed(() => {
  return mediaCollection.mediaCollection.value.toSorted((a, b) => {
    return b.custom_properties.period.slice(0, 10).localeCompare(a.custom_properties.period.slice(0, 10));
  });
});

const selectReport = (index: number) => {
  selectedReport.value = orderedReports.value[index];
};

watch(orderedReports, (newValue) => {
  if(newValue && newValue.length > 0) {
    selectedReport.value = newValue[0];
  }
}, { immediate: true });

watch(() => props.projectId, (newValue, oldValue) => {
  if(oldValue && newValue && newValue !== oldValue) {
    router.push({ name: 'ReportsIndex', params: { projectId: newValue } });
  }
}, { immediate: true });

// Watch for changes in report data and redirect if save_export is disabled
watch(report, (newReport) => {
  if(newReport && !newReport.save_export) {
    router.replace({
      name: 'ReportEditor',
      params: {
        projectId: props.projectId,
        reportId: props.reportId,
      },
    });
  }
}, { immediate: true });

const showReportsAction = useStoreApiAction(reportsStore.show);

// Fetch report data and media when component mounts
watch(() => props.reportId, async (newValue) => {
  if(newValue) {
    mediaCollection.clear();

    const reportData = await showReportsAction.request(newValue);

    if(reportData.data.media) {
      mediaCollection.addMedia(reportData.data.media);
    }
  }
}, { immediate: true });

const transformPeriod = (date: string) => {
  const start = date.slice(0, 10);
  const end = date.slice(11, 22);

  return `${DateTime.fromFormat(start, 'yyyy-MM-dd').toLocaleString()} to ${
    DateTime.fromFormat(end, 'yyyy-MM-dd').toLocaleString()
  }`;
};

const generateReportAction = useStoreApiAction(reportsStore.generate);
const reportMonth = ref(dateForMonthInput(new Date()));

const exportMonthlyReport = () => {
  generateReportAction.request(props.reportId, { month: reportMonth.value }).then(() => {
    Swal.fire({
      icon: 'success',
      title: 'Monthly Report Generating',
      text: 'You will be emailed the report when it is done.',
    });
  }).catch((error) => {
    if(error.status === 429) {
      Swal.fire({
        icon: 'error',
        title: 'PDF is currently being exported',
        text: error.data.message,
      });
    } else if(error.status === 422) {
      Swal.fire({
        icon: 'error',
        title: 'Failed to Export.',
        text: error.data.message,
      });
    }
  });
};
</script>

<style scoped></style>
